import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route  } from 'react-router-dom';
import { LanguageProvider } from './Contexts/LanguageContext';
import Header from './Components/Header/Header';
import SplashScreen from './Pages/SplashScreen/SplashScreen';
import JLRLanding from './Pages/JLRLanding/JLRLanding';
import Footer from './Components/Footer/Footer';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import './App.scss';

const TRACKING_ID = "G-0Y4L9P03EV";
ReactGA.initialize(TRACKING_ID);

const App = () => {
  const [validated, setValidated] = useState(false);

  useEffect(() => {    
    ReactGA.pageview(window.location.pathname + window.location.search);
    // Log any errors from react-ga
    ReactGA.ga('send', 'exception', {
      exDescription: 'react-ga initialization error',
      exFatal: false,
    });

    // Initialize Google Tag Manager
    const GTM_ID = "G-0Y4L9P03EV"; // Replace with your GTM container ID
    TagManager.initialize({ gtmId: GTM_ID });

    // Check local storage for validation
    const isUserValidated = localStorage.getItem('validated');
    if (isUserValidated) {
      setValidated(true);
    }
  }, []);

  

  const handleValidationSuccess = () => {
    setValidated(true);
    localStorage.setItem('validated', 'true');
  };

  return (
    <>
    <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
      <LanguageProvider>        
      {validated && <Header />}
        <Routes>          
        <Route
              path="/"
              element={
                validated ? (
                  <JLRLanding />
                ) : (
                  <SplashScreen onValidationSuccess={handleValidationSuccess} />
                )
              }
            />
        </Routes>        
        {validated && <Footer />}
      </LanguageProvider> 
    </BrowserRouter>
           
    </>
  );
}

export default App;
